import styled from 'styled-components'
import { themeGet } from 'styled-system'
import MarkCompleteButtonIcon from 'components/MarkCompleteButtonIcon'

export const MarkCompleteButton = styled.button`
  height: 2.688rem;
  min-width: 9.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: ${props => {
    if (!props.useSecondaryMarkCompleteButton) {
      return 'none'
    }
    return `0.125rem solid ${themeGet(
      'colors.buttons.primary.bgActive',
      '#007a87',
    )(props)}`
  }};
  font-family: ${themeGet('fonts.moldeMedium16.fontFamily', 'Molde-medium')};
  font-size: ${themeGet('fonts.moldeMedium16.fontSize', '1rem')};
  line-height: ${themeGet('fonts.moldeMedium16.lineHeight', '1.063rem')};
  cursor: ${props => (props.isComplete ? 'default' : 'pointer')};
  background-color: ${props => {
    if (props.useSecondaryMarkCompleteButton) {
      return themeGet('colors.white', '#ffffff')
    }
    if (props.isComplete) {
      return themeGet('colors.paleGray', '#EEF0F2')
    }
    return themeGet('colors.buttons.primary.bgActive')
  }};
  color: ${props => {
    if (props.useSecondaryMarkCompleteButton) {
      return themeGet('colors.buttons.primary.bgActive', '#007a87')
    }
    if (props.isComplete) {
      return themeGet('individualResource.markCompleteButton.color')
    }
    return themeGet('colors.buttons.primary.titleActive')
  }};

  &:hover {
    background-color: ${props => {
      if (props.useSecondaryMarkCompleteButton) {
        return themeGet('colors.white', '#ffffff')
      }
      if (props.isComplete) {
        return themeGet('colors.paleGray', '#EEF0F2')
      }
      return themeGet('individualResource.activityDetails.button.hover.color')
    }};
    color: ${props => {
      if (props.useSecondaryMarkCompleteButton) {
        return themeGet('colors.buttons.primary.bgHover', '#006874')
      }
      if (props.isComplete) {
        return themeGet('individualResource.markCompleteButton.color')
      }
      return themeGet('colors.buttons.primary.titleHover')
    }};
    border-color: ${props =>
      props.useSecondaryMarkCompleteButton
        ? themeGet('colors.buttons.primary.bgHover', '#006874')(props)
        : 'transparent'};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: ${props => (props.useSecondaryMarkCompleteButton ? 1 : 0.6)};
  }

  ${themeGet('breakpoints.tabletLarge')} {
    margin-bottom: 1.25rem;
  }
`

export const MarkCompleteIconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ThemedMarkCompleteButtonIcon = styled(
  MarkCompleteButtonIcon,
).attrs({
  fillColor: props =>
    props.useSecondaryMarkCompleteButton
      ? themeGet('colors.buttons.primary.bgActive', '#007a87')(props)
      : themeGet(
          'individualResource.markCompleteButton.color',
          '#555555',
        )(props),
})`
  height: 1rem;
  width: 1rem;
  display: block;
  vertical-align: middle;
  margin-bottom: 0.1rem;
`
